var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart-container',{attrs:{"title":_vm.title}},[(_vm.options.results.length > 0)?_c('div',{style:({
      'overflow-y': 'scroll',
      'max-height': (_vm.computedHeigth + "px"),
    })},_vm._l((_vm.options.results),function(r){return _c('v-row',{key:r._id,attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('result',{attrs:{"id":r._id,"source":r._source,"hits":r.inner_hits,"elevation":6}})],1)],1)}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }